<template>
  <div ref="container" class="ai-chat-message-text">{{ text }}</div>
</template>

<script>
let timeout;

export default {
  props: {
    message: {
      type: Object,
    },
  },
  computed: {
    text() {
      return this.message.content;
    },
  },
  watch: {
    text: {
      handler(newVal, oldVal) {
        this.$refs.container.textContent = newVal;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-chat-message-text {
  display: flex;
  padding: 16px;
  color: #fff;
  font-feature-settings: 'dlig' on;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  white-space: pre-wrap;
}
</style>
